﻿import { addValidationRule, Decorators, EditorProps, EditorWidget, IStringValue } from "@serenity-is/corelib";

@Decorators.registerClass('Matrix.MinHeightEditor', [IStringValue])
export class MinHeightEditor extends EditorWidget<{}> implements IStringValue {
    static override createDefaultElement() { return <input type="text"/> as HTMLInputElement; }

    declare readonly domNode: HTMLInputElement;

    constructor(opt: EditorProps<any>) {
        super(opt);
        addValidationRule(this.domNode, () => this.validateValue());
        this.element.on("beforeinput", (e) => this.validateBeforeInput(e));
        this.element.on("input", (e) => this.appendXIfNeeded(e as InputEvent));
    }

    private validateValue(val?: string): string {
        val ??= this.domNode.value?.trim();
        if (!val)
            return;

        for (let charIdx = 0; charIdx < val.length; charIdx++) {
            const char = val[charIdx];
            if (char >= '0' && char <= '9')
                continue;

            if (charIdx !== 0 &&
                ((charIdx === val.length - 2 && val.substring(charIdx) === 'px') ||
                (charIdx === val.length - 1 && val[charIdx] === '%')))
                return;

            return 'Min Height must be a number followed by "px" or "%" or just a number.';
        }

        return;
    }

    private validateBeforeInput(e: InputEvent): boolean | void {
        if (!["insertText", "insertFromPaste"].includes(e.inputType ?? e["originalEvent"]?.inputType))
            return;

        const value = this.domNode.value.substring(0, this.domNode.selectionStart ?? 0) +
            (e.data ?? e["originalEvent"]?.data ?? '') +
            this.domNode.value.substring(this.domNode.selectionEnd ?? 0);

        if (this.validateValue(value) == null)
            return;

        if (value.length > 1 && !value.includes("px") && value.endsWith("p"))
            return;

        return false;
    }

    private appendXIfNeeded(e: InputEvent): void {
        if ((e.inputType ?? e["originalEvent"]?.inputType) !== "insertText")
            return;

        const val = this.domNode.value;
        if (!val)
            return;

        if (val.endsWith("p"))
            this.domNode.value += "x";
    }

    get_value(): string {
        const val = this.domNode.value?.trim();
                        return !val ? '' : val;
    }

    set_value(value: string): void {
        if (value == null || (value as any) === '')
            this.domNode.value = '';
        else
            this.domNode.value = this.formatValue(value);
    }

    private formatValue(value: string | number): string {
        const strValue = value.toString();
        let formatted = strValue.replace(/[^0-9]/g, '');
        if (strValue.includes('px'))
            return `${formatted}px`

        if (strValue.includes('%'))
            return `${formatted}%`

        return formatted;
    }
}